import { QueryFactory, VisitTypeDto } from '@lmt/shared-types';

export function useActiveVisitTypes(selectedValue?: number | null) {
  return (
    QueryFactory.VisitTypeQuery.useGetQuery({
      select: (data: VisitTypeDto[]) =>
        (data ?? [])?.filter((x) => !x.isDeleted || x.id === selectedValue),
    }).data ?? []
  );
}

export function useVisitTypes() {
  return QueryFactory.VisitTypeQuery.useGetQuery().data ?? [];
}
